import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserInfoPage } from './user-info';

@NgModule({
  declarations: [
    UserInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(UserInfoPage),
  ],
})
export class UserInfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-info/user-info.module.ts